import DoctorSignature, { DoctorSignatureFooter, SIGNATURE_FOOTER_SPACE } from "./DoctorSignature";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { drName } from "../redux/apiUrl";
import { store } from "../redux/store";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});
const eliminarA = (dato) => {
  let array_final = "";
  for (let i = 0; i < dato.length; i++) {
    if (dato[i] + dato[i + 1] === "A0") {
      // Saltar hasta el siguiente espacio
      while (i < dato.length && dato[i] !== " ") {
        i++;
      }
    }
    // Agregar el carácter a la cadena final solo si no se ha saltado
    array_final += dato[i];
  }

  return array_final.replace(/[,\-|]/g, "\n");
};

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#fff",
    paddingBottom: SIGNATURE_FOOTER_SPACE, // Último valor definido
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  logo: {
    width: "100%",
    height: "15%",
  },
  headerright: {
    width: "auto",
    height: "45%", // Último valor definido
  },
  headerright: {
    width: "auto",
    height: "40%", // Último valor definido
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 20,
  },
  subtitle: {
    textAlign: "left",
    fontSize: 14, // Último valor definido
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 700,
    marginBottom: 20,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  bold: {
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 600,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.1,
    zIndex: "-10",
  },
  textBold: { fontWeight: 700 },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
  },
  information_title: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    fontFamily: "Roboto",
    paddingTop: 10,
    paddingBottom: 10,
  },
  // Propiedades faltantes del primer objeto
  gridItem: {
    width: "48%",
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 5,
    fontFamily: "Roboto",
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    paddingHorizontal: 30,
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 80,
  },
});
const OrdenPdf = ({ data }) => {
  const orden = [];
  const catalog =
    Array.isArray(data?.laboratorios) && data.laboratorios.length > 0
      ? data.laboratorios
      : store.getState()?.laboratorios2?.data || [];

  if (data?.orden?.tipo !== "Analisis de Gabinete") {
    if (Array.isArray(data?.orden?.resultados)) {
      data.orden.resultados.forEach((resultado) => {
        catalog.forEach((lab) => {
          if (resultado.laboratorios_id === lab.id) {
            orden.push(lab.nombre);
          }
        });
      });
    }
  } else {
    Object.keys(data.orden).forEach((key) => {
      if (
        data?.orden[key] &&
        !key.includes("resultado") &&
        !key.includes("_at") &&
        key !== "nombre" &&
        key !== "tipo" &&
        key !== "id" &&
        key !== "cita_id"
      ) {
        orden.push(key.replaceAll("_", " ").toUpperCase());
      }
    });
  }

  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.watermark} src="/images/longLogo.png" />
        <Image style={styles.logo} src="/images/headerright.png" />

        {/* Title */}
        {data?.orden?.tipo === "Analisis de Gabinete" ? (
          <Text style={styles.title}>ORDEN {data?.orden?.nombre}</Text>
        ) : (
          <Text style={styles.title}>ORDEN DE ESTUDIO DE LABORATORIO</Text>
        )}

        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {data?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Edad:</Text> {data?.edad}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
              {data?.lugarAtencion}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Diagnostico:</Text>{" "}
              {data?.diagnostico}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Seguro:</Text> {data?.seguro}
            </Text>
            {data?.orden?.tipo && (
              <Text style={styles.text}>
                <Text style={styles.textBold}>Tipo:</Text> {data?.orden?.tipo}
              </Text>
            )}

            <Text style={styles.text}>
              <Text style={styles.textBold}>Peso:</Text> {data.peso} kg
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Altura:</Text> {data.altura} cm
            </Text>
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>

          {orden.length > 0 ? (
            // Si hay elementos, accede DIRECTAMENTE al primero (índice 0)
            // No es necesario usar .map()
            data?.orden?.tipo === "Laboratorio" ? (
              orden.map((o, index) => {
                return (
                  <View style={styles.section} key={index}>
                    <Text style={styles.text}>{`${index + 1}). ${o}`}</Text>
                  </View>
                );
              })
            ) : (
              <View style={styles.section}>
                <Text style={styles.text}>
                  <Text style={styles.textBold}>Nombre:</Text>{" "}
                  {data?.orden?.nombre}
                </Text>
                <Text style={styles.text}>
                  <Text style={styles.textBold}>Descripción:</Text>{" "}
                  {data?.orden?.descripcion}
                </Text>
              </View>
            )
          ) : (
            // Tu código para cuando el array está vacío (esto no cambia)
            <View style={styles.section}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Nombre:</Text>{" "}
                {data?.orden?.nombre}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Descripción:</Text>{" "}
                {data?.orden?.descripcion}
              </Text>
            </View>
          )}
        </View>

        <DoctorSignatureFooter>
          <DoctorSignature doctor={data?.doctor} />
        </DoctorSignatureFooter>

        {/* Footer */}
        {/* <Image fixed style={styles.footerImage} src="/images/footerImage.png" /> */}
      </Page>
    </Document>
  );
};

export default OrdenPdf;
